export const getPageInfo = ( state) => {
    return state.all
}

export const getCurrentLinkPromotion = ( state) => {
    return state.linkPromotion
}